<template>
  <div class="flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto">
    <div class="w-full h-12 p-4 shadow-md ">
      <span class="text-large text-black text-bold font-600 mr-3">Layout3</span>
    </div>

    <div class="flex flex-col px-4 gap-4 mt-4 w-full items-center">
      <el-button class="w-24" type="primary" @click="drawer = true">
        open
      </el-button>

      <el-button plain @click="open2"> Won't close automatically </el-button>

      <el-button type="primary" @click="openFullScreen2"> As a service </el-button>

      <el-drawer v-model="drawer" :size="300" title="I am the title" :with-header="false">
        <span>Hi there!</span>
      </el-drawer>

      <div class="flex flex-col gap-4 mt-4 w-full">
        <el-alert title="Success alert" type="success" />
        <el-alert title="Info alert" type="info" />
        <el-alert title="Warning alert" type="warning" />
        <el-alert title="Error alert" type="error" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { ElNotification, ElLoading } from 'element-plus';
export default defineComponent({
  name: 'Layout3',
  setup() {
    // https://element-plus.org/zh-CN/component/drawer.html
    const drawer = ref(false);

    const open2 = () => {
      ElNotification({
        title: 'Prompt',
        message: 'This is a message that does not automatically close',
        duration: 0,
      })
    }

    const openFullScreen2 = () => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
    }

    return {
      drawer,
      open2,
      openFullScreen2
    }
  }
});
</script>